(function () {
  function swymCallbackFn(swat) {
    document.addEventListener("swym:collections-loaded", function (e) {
      window._swat.initializeActionButtons(".usf-grid");
    });
    function loaded(e, v) {
      let selector = e.detail.selector;
      let id = e.detail.section.id;
      if (!selector && !id) {
        return;
      }

      if (!selector) {
        selector = `#${id}`;
      }
      window._swat.initializeActionButtons(selector);
    }
    document.addEventListener("recommendations:loaded", loaded);
    document.addEventListener("products:loaded", loaded);
    document.addEventListener("emarsys:loaded", loaded);
  }

  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(swymCallbackFn);
  /* Called when swym is loaded! */

  function swymIntCallbackFn(tracker){
    tracker.evtLayer.addEventListener(tracker.JSEvents.readRetailerConfig, function(e){
      Object.assign(window._swat.retailerSettings.Strings, window.swymTranslation);

      // Special handle
      var title = window.swymTranslation.WishlistMainTitle;
      if (title && !title.startsWith('translation missing')) {
        window._swat.retailerSettings.UI.Title = title;
      }
    });
  }
  window.SwymIntCallbacks = window.SwymIntCallbacks || [];
  window.SwymIntCallbacks.push(swymIntCallbackFn);

  console.log('Swym Callbacks loaded');
  autoAddProductGWP();
  
})();

const waveCartUtils = (function () {
  function post (url, body) {
    return fetch(url, {
      method: "POST",
      body: JSON.stringify(body),
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
      },
    });
  }

  function get (url) {
    return fetch(url, {
      credentials: "same-origin",
      method: "GET",
    });
  }

  function getCart () {
    var url = "".concat(theme.routes.cart, `?t=${Date.now()}`);
    return get(url).then((response) => response.json());
  }

  function changeItem ({
    key,
    quantity,
    properties,
  }) {
    return post(theme.routes.cartChange, {
      id: key,
      quantity: quantity,
      properties: properties,
    });
  }

  function addItems (
    items,
    sections,
    sections_url,
  ) {
    return post(theme.routes.cartAdd, {
      items,
      sections,
      sections_url,
    });
  }

  async function clearAddOn () {
    const cart = await getCart();
    const unissuedAddOns = cart.items.filter((item) => {
      return (
        item.properties["__add_on"] && !item.properties["__add_on"]["issued"]
      );
    });

    const param = { updates: {} };
    for (const item of unissuedAddOns) {
      param.updates[item.key] = 0;
    }
    await post(theme.routes.cartUpdate, param);
    return unissuedAddOns.length > 0;
  }

  return {
    changeItem: changeItem,
    getCart: getCart,
    addItems: addItems,
    clearAddOn: clearAddOn
  };
})();

class wcAddonPopup extends HTMLElement {
  constructor() {
    super();

    const _this = this;
    this.querySelectorAll('.js-close-addon-popup').forEach(ele => {
      ele.addEventListener('click', (e) => {
        e.stopPropagation();
        e.preventDefault();

        _this.hide();
      })
    })

    document.addEventListener('wcAddonPopup:lock', async (e) => {
      _this.lock();
    });
    document.addEventListener('wcAddonPopup:unlock', async (e) => {
      _this.unlock();
    });
    document.addEventListener('wcAddonPopup:open', async (e) => {
      const productHandle = e?.detail?.productHandle;
      if (!productHandle) return;

      const popupHtml = await this.fetchPopup(productHandle);
      this.show();
      this.render(popupHtml);

      // hide Special offer product popup when opening the popup
      const addonCollectionRow = document.querySelectorAll('.addon-collection-row ');
      addonCollectionRow.forEach((row) => {
        if( !row.querySelector('.addon-product-grid > div')) {
          row.classList.add('hidden');
        }
      });
    });

    document.addEventListener('ajaxProduct:added', async (e) => {
      const productHandle = e?.detail?.productHandle;
      console.log("ajaxProduct:added", e.detail)
      const isAddon = e?.detail?.isAddon;
      if (!productHandle) return;

      const popupHtml = e.detail.isAddon ? e.detail.popupHtml : await this.fetchPopup(productHandle);

      const el= document.createElement( 'div' );
      el.innerHTML = popupHtml;
      const isEmpty = el.children[0].children.length === 0;

      const autoAddGifts = el.querySelectorAll('[data-auto-add-gift]')
      console.log("autoAddGifts.length",autoAddGifts, autoAddGifts.length, isAddon, isEmpty)
      if (autoAddGifts.length > 0 && !isAddon) {
        await this.autoAddGiftsToCart(autoAddGifts);
      } else if (!isEmpty) {
        // this.show();
        this.render(popupHtml);      
      }
      // auto add gift products
      autoAddProductGWP();
    });
  
    document.addEventListener('wcAddonPopup:qtyUpdated', async (e) => {
      const productHandle = e?.detail?.productHandle;
      if (!productHandle) return;
  
      const popupHtml = await this.fetchPopup(productHandle);
  
      const el= document.createElement('div');
      el.innerHTML = popupHtml;
  
      const autoAddGifts = el.querySelectorAll('[data-auto-add-gift]')
      console.log("autoAddGifts>>>", autoAddGifts)
      if (autoAddGifts.length > 0) {
        await this.autoAddGiftsToCart(autoAddGifts);
      }
      // auto add gift products
      autoAddProductGWP();
    });
  }

  async autoAddGiftsToCart(gifts) {
    gifts.forEach(async gift => {
      const usedCount = parseInt(gift.dataset.usedCount);
      const quota = parseInt(gift.dataset.quota);

      console.log(gift.dataset)
      console.log(usedCount, quota)

      if (usedCount < quota) {
        const rule = JSON.parse(gift.dataset.rule);
        delete rule.issued_count;
        const resp = await waveCartUtils.addItems([{
          quantity: quota - usedCount,
          id: parseInt(gift.dataset.variantId),
          properties: {
            __add_on: {
              rule: rule, //JSON.parse(gift.dataset.rule),
              set: gift.dataset.addonSet,
              __free_gift: true

            }
          }
        }], 'gpwp-popup', `/products/${gift.dataset.qualifyingProductHandle}`)

        if (resp.status === 422) {
        } else {
          document.dispatchEvent(new CustomEvent('cart:build'));
        }
      }
    });                    
  }

  lock () {
    this.dataset.lockCount = parseInt(this.dataset.lockCount) + 1;
  }

  unlock () {
    this.dataset.lockCount = parseInt(this.dataset.lockCount) - 1;
  }

  show () {
    document.body.classList.add('overflow-hidden');
    this.style.display = 'block';
  }

  hide () {
    document.body.classList.remove('overflow-hidden');
    this.style.display = 'none';
    this.querySelector('.popup-content').innerHTML = '';

    const addOnPopup = document.querySelectorAll('[data-addon-button]');
    addOnPopup.forEach((popup) => {
      // remove clicked attribute
      popup.removeAttribute('data-clicked');
    });
  }

  async fetchPopup (productHandle) {
    const url = `${theme.routes.home}/products/${productHandle}?sections=gpwp-popup`.replace('//', '/');
    const resp = await fetch(url);
    const json = await resp.json();
    return json['gpwp-popup'];
  }

  render (popupHtml) {
    let tempElement = document.createElement('div');
    tempElement.innerHTML = popupHtml;

    const _this = this;
    tempElement.querySelectorAll('.addon-collection-row').forEach(row => {
      const ruleId = row.dataset.ruleId;
      const currentRow = this.querySelector(`.addon-collection-row[data-rule-id="${ruleId}"]`);

      // hide Special offer product popup when adding to cart via
      if( !row.querySelector('.addon-product-grid > div')) {
        row.classList.add('hidden');
      }
      
      if (currentRow) {
        currentRow.className = row.className;

        currentRow.replaceChild(
          row.querySelector('.addon-collection-row-title'),
          currentRow.querySelector('.addon-collection-row-title')
        );

        const handleToGridItemMap = new Map();
        row.querySelectorAll('.grid-item.grid-product').forEach(item => {
          handleToGridItemMap.set(item.dataset.productHandle, item);
        });
        const flickityInstance = Flickity.data(currentRow.querySelector('.flickity-enabled'));

        if(flickityInstance ) {
          for (const cell of flickityInstance.getCellElements()) {
            const currentItem = cell.querySelector('.grid-item');
            const productHandle = currentItem.dataset.productHandle;
            if (handleToGridItemMap.has(productHandle)) {
              const newItem = handleToGridItemMap.get(productHandle);
              cell.innerHTML = newItem.outerHTML;
              handleToGridItemMap.delete(productHandle);
            } else {
              flickityInstance.remove(cell);
            }
          }
          for (const [_, item] of handleToGridItemMap) {
            flickityInstance.append(item.parentNode);
          }
        }
      } else {
        this.querySelector('.popup-content').appendChild(row);
        // const flickityInstance = new Flickity(row.querySelector('.addon-product-grid'), {
        //   accessibility: false,
        //   prevNextButtons: true,
        //   pageDots: false,
        //   contain: false,
        //   cellAlign: 'left',
        //   lazyLoad: false,
        //   adaptiveHeight: false,
        //   percentPosition: false,
        //   draggable: false,
        //   groupCells: true,
        //   selectedAttraction: 0.3,
        //   friction: 0.8,
        //   fade: false,
        // });
        // setTimeout(() => {
        //   flickityInstance.resize();
        // }, 1000);
        // window.on('resize', theme.utils.debounce(100, function () {
        //   flickityInstance.resize();
        // }));
      }
    });
  }
}
customElements.define('wc-addon-popup', wcAddonPopup);

class wcAddonQuickAddButton extends HTMLElement {
  constructor() {
    super();

    const btn = this.querySelector('button');
    btn.addEventListener('click', async () => {
      document.dispatchEvent(new CustomEvent('wcAddonPopup:lock'));
      try {
        const tmp = btn.closest('[data-rule]');
        const rule = JSON.parse(tmp.dataset.rule);
        const addonSet = tmp.dataset.addonSet;
        const variantId = btn.dataset.id;
        delete rule.issued_count;
        delete rule.issued_tier;

        const resp = await waveCartUtils.addItems([{
          quantity: 1,
          id: variantId,
          properties: {
            __add_on: {
              rule,
              set: addonSet,
            }
          }
        }], 'gpwp-popup', `/products/${tmp.dataset.qualifyingProductHandle}`)

        if (resp.status === 422) {
        } else {
          const json = await resp.json();
          const popupHtml = json['sections']['gpwp-popup'];
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
            detail: {
              product: json.items[0],
              addToCartBtn: btn,
              isAddon: true,
              popupHtml,
            }
          }));

          // update the count used for the add-on product
          const addOnProductCount = document.querySelector(`.addon-collection-row-title[data-variant-id="${variantId}"]`);
          if(addOnProductCount) {
            const countContent = addOnProductCount.textContent.trim().replace('[', '').replace(']', '').split(' / ')[0];
            let count = parseInt(countContent) + 1;
            let quota = parseInt(addOnProductCount.dataset.quota);
            let usedCount = `[${count} / ${quota}]`;
            
            addOnProductCount.innerHTML = usedCount;

            // disable quick add button if the count is equal to the quota
            if (count >= quota) {
              addOnProductCount.parentNode.parentNode.classList.add('disabled');
            }
          }
     
          // auto add gift products
          autoAddProductGWP();
        }
      } finally {
        document.dispatchEvent(new CustomEvent('wcAddonPopup:unlock'));
      }
    })
  }
}
customElements.define('wc-addon-quick-add-button', wcAddonQuickAddButton);

class wcAddonPopupButton extends HTMLElement {
  constructor() {
    super();

    this.productHandle = this.dataset.productHandle;
    const _this = this;
    this.querySelector('button').addEventListener('click', function () {
      document.dispatchEvent(new CustomEvent('wcAddonPopup:open', {
        detail: {
          productHandle: _this.productHandle,
        }
      }));
    });
  }
}
customElements.define('wc-addon-popup-button', wcAddonPopupButton);

document.addEventListener('cart:updated', (e) => { console.log(e); autoAddProductGWP(); });
document.addEventListener('ajaxProduct:added', (e) => { console.log(e); autoAddProductGWP();});

waveCartUtils.clearAddOn().then(updated => {
  if (updated) {
    document.dispatchEvent(new CustomEvent('cart:build'));
  }
});
document.addEventListener('cart:updated', async (e) => {
  const updated = await waveCartUtils.clearAddOn();
  
  const key = e?.detail?.key;
  const cart = e?.detail?.cart;
  if (key && cart) {
    const k = key.split(':')[0];
    const item = cart.items.find(item => item.key.startsWith(k));

    // auto add gift products
    autoAddProductGWP()

    document.dispatchEvent(new CustomEvent('wcAddonPopup:qtyUpdated', {
      detail: {
        productHandle: item?.handle,
      }
    }));
  }
  
  if (updated) {
    document.dispatchEvent(new CustomEvent('cart:build'));
  }
});

class wcProductItemPrice extends HTMLElement {
  constructor() {
    super();
  }

  static get observedAttributes() { return ['data-product']; }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'data-product') {
      const product = (() => {
        try { return JSON.parse(this.dataset.product) } catch (e) { return undefined; }
      })();

      if (!product) return;

      const isAddonGift = this.dataset.isAddonGift === 'true';
      const addonSet = this.dataset.addonSet;

      const groupDiscountTag = window.wcGroup ? product.tags.find(tag => tag.startsWith(window.wcGroup)) : '';
      const groupPercentageOff = groupDiscountTag ? Math.min(100, Number(groupDiscountTag.split('|')[0].split(':')[1].replace('%', ''))) : 0;
      const source = this.dataset.source;
      const variants = product.variants.map(v => {
        const ret = source === 'shopify' ?
          {
            compareAtPriceInCent: Number(v.compare_at_price || v.price),
            priceInCent: Number(v.price),
          } :
          {
            compareAtPriceInCent: Math.round(Number(v.compareAtPrice || v.price) * 100),
            priceInCent: Math.round(Number(v.price) * 100),
          };
        ret.originalPriceInCent = ret.compareAtPriceInCent || ret.priceInCent;
        /* check */
        ret.finalPriceInCent = Math.max(
          0,
          Math.min(
            Math.floor(ret.originalPriceInCent * (100 - groupPercentageOff) / 10000) * 100,
            ret.priceInCent
          )
        )

        if (addonSet) {
          if (isAddonGift) {
            ret.finalPriceInCent = 0;
          } else {
            const tag = product.tags.find(t => t.startsWith(`set:${addonSet}|discount`));
            const tmp = tag.split('|')[1].split(':');
            const discountType = tmp[0];
            switch (discountType) {
              case 'discount':
              case 'discount-amount':
                ret.finalPriceInCent = Math.max(
                  0,
                  Math.min(
                    ret.finalPriceInCent,
                    ret.originalPriceInCent - tmp[1] * 100
                  )
                )
                break;
              case 'discount-percent':
                ret.finalPriceInCent = Math.max(
                  0,
                  Math.min(
                    ret.finalPriceInCent,
                    ret.originalPriceInCent- ret.compareAtPriceInCent * tmp[1] / 100
                  )
                )
                break;
            }
          }
        }
        return ret;
      }).sort((x, y) => x.finalPriceInCent - y.finalPriceInCent);
      const { finalPriceInCent, originalPriceInCent } = variants[0];
      const priceVaries = (new Set(variants.map(i => i.finalPriceInCent))).size > 1;
      this.render(finalPriceInCent, originalPriceInCent, priceVaries);
       setTimeout( () => {
        this.renderPercentageOff(finalPriceInCent, originalPriceInCent);
        this.renderPromoBox(product);
        this.renderPromoBoxFromTag(product);
        this.renderPromoBoxBuyXGetYOff(product);
      });
    }
  }

  renderPercentageOff(finalPriceInCent, originalPriceInCent) {
    const percentageOff = Math.round(100 - (finalPriceInCent / originalPriceInCent * 100));
    const ELM_product = this.closest('.grid-product');
    const ELM_tagSale = ELM_product?.querySelector('.grid-product__tag--sale');

    if (percentageOff) {
      if (ELM_tagSale) {
        ELM_tagSale.innerHTML = percentageOff + '% OFF';
      } else {
        const ELM_productTags =  ELM_product?.querySelector('.grid-product__tags');
        ELM_productTags.innerHTML += `<div class="grid-product__tag grid-product__tag--sale">${ percentageOff }% OFF</div>`;
      }
    }
  }

  renderPromoBoxBuyXGetYOff(product) {
    const promoPrefix = `promo_message_`;
    const promoMessagetag = product.tags.find(tag => tag.search(promoPrefix) > -1);
    if (promoMessagetag) return;

    const tag = product.tags.find(tag => tag.search('rule:groupDiscount') > -1 && tag.search('|sum') < 0);
    const ELM_product = this.closest('.grid-product');
    const ELM_productMeta = ELM_product.querySelector('.grid-item__meta-main');
    if (!tag || !ELM_productMeta) return;
    const type = tag.search('quantity') > -1 ? 'quantity' : 'total';
    const promo = tag.split('|');
    let promoBoxHtml = '';

    if (type === 'quantity') {
      const quantity = promo.find(p => p.search('quantity') > -1).split(':')[1];
      const percent = promo.find(p => p.search('percent') > -1).split(':')[1];
      promoBoxHtml = `<div class="promo-box">
        <h6>${ theme.strings.buyXPcsGetYOff.detail.replace('[X]', quantity).replace('[Y]', percent) }</h6>
      </div>`;
    }

    if (type === 'total') {
      const total = promo.find(p => p.search('total') > -1).split(':')[1];
      const percent = promo.find(p => p.search('percent') > -1).split(':')[1];
      promoBoxHtml = `<div class="promo-box">
        <h6>${ theme.strings.buyXGetYOff.detail.replace('[X]', total).replace('[Y]', percent) }</h6>
      </div>`;
    }

    ELM_productMeta.innerHTML = promoBoxHtml + ELM_productMeta.innerHTML;
  }

  renderPromoBoxFromTag(product) {
    const lang = document.documentElement.lang === 'zh-TW' ? 'zh' : 'en';
    const promoPrefix = `promo_message_${lang}:`;
    const tag = product.tags.find(tag => tag.search(promoPrefix) > -1);
    console.log('---tag', tag)
    const ELM_product = this.closest('.grid-product');
    const ELM_productMeta = ELM_product.querySelector('.grid-item__meta-main');
    if (!tag || !ELM_productMeta) return;

    const messages = tag.replace(promoPrefix, '').split('__');

    const promoBoxHtml = `<div class="promo-box">
      <h6>${ messages[0] }</h6>
      ${messages[1] ? `<p>${ messages[1] }</p>` : ''}
    </div>`;

    ELM_productMeta.innerHTML = promoBoxHtml + ELM_productMeta.innerHTML;
  }

  renderPromoBox(product) {
    const TAG_QUALIFIER = 'D11-22-30off';
    const ELM_product = this.closest('.grid-product');
    const ELM_productMeta = ELM_product.querySelector('.grid-item__meta-main');
    const isEligible = product.tags.findIndex(tag => tag === TAG_QUALIFIER) > -1;
    if (!ELM_product.dataset.usfPid || !ELM_productMeta || !isEligible) return;

    const promoBoxHtml = `<div class="promo-box">
      <h6>${ theme.strings.promoBox.detail }</h6>
      <p>${ theme.strings.promoBox.condition }</p>
    </div>`;

    ELM_productMeta.innerHTML = promoBoxHtml + ELM_productMeta.innerHTML;
  }

  // number in cents
  render (finalPriceInCent, originalPriceInCent, priceVaries) {
    // console.log({
    //   finalPriceInCent,
    //   originalPriceInCent,
    //   priceVaries
    // });
    const onSale = finalPriceInCent < originalPriceInCent;
    let html = '';

    if (priceVaries) {
      const fromTextHtml = "\u003cspan\u003efrom\u003c\/span\u003e {{ price }}".replace('{{ price }}', theme.Currency.formatMoney (finalPriceInCent));
      html = `
        <span class="grid-product__price--current">
          <span aria-hidden="true" class="grid-product__price--from">${fromTextHtml}</span>
        </span>
      `;
    } else {
      const cls = onSale ? 'grid-product__price--on-sale' : '';
      html = `
        <span class="grid-product__price--current ${cls}">
          <span aria-hidden="true">${theme.Currency.formatMoney (finalPriceInCent)}</span>
        </span>
      `;
    }

    if (onSale) {
      html += `
        <span class="grid-product__price--original">
          <span aria-hidden="true">${theme.Currency.formatMoney (originalPriceInCent)}</span>
        </span>
      `
    }

    this.innerHTML = html;
  }
}
customElements.define('wc-product-item-price', wcProductItemPrice);

class wcGroupDiscountBadge extends HTMLElement {
  constructor() {
    super();
  }

  static get observedAttributes() { return ['data-tags']; }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name !== 'data-tags') {
      return;
    }

    const tags = JSON.parse(this.dataset.tags);

    const groupDiscountTag = window.wcGroup ? tags.find(tag => tag.startsWith(window.wcGroup)) : '';
    const groupPercentageOff = groupDiscountTag ? Math.min(100, Number(groupDiscountTag.split('|')[0].split(':')[1].replace('%', ''))) : 0;

    this.render(groupPercentageOff);
  }

  render(amount) {
    if (!amount) return;

    this.innerHTML = `-${amount}%`;
    this.style.display = 'flex';
  }
}
customElements.define('wc-group-discount-badge', wcGroupDiscountBadge);

class WcVideo extends HTMLElement {
  constructor() {
    super();

    this.querySelector('[wc-play-button]')?.addEventListener('click', this.playVideo.bind(this));
    this.querySelector('[wc-close-button]')?.addEventListener('click', this.pauseVideo.bind(this));
  }

  playVideo() {
    if (this.hasAttribute('wc-play-in-popup')) {
      this.classList.add('open-popup');
    }
    this.classList.add('playing');
    this.querySelector('video')?.play();
  }

  pauseVideo() {
    this.classList.remove('open-popup');
    this.classList.remove('playing');
    this.querySelector('video')?.pause();
  }
}
customElements.define('wc-video', WcVideo);

async function autoAddProductGWP() {
  const enablePromotion = theme.gwpBuyXGetY.enable; 
  const PRODUCT_A_ID = theme.gwpBuyXGetY.set1.id; 
  const PRODUCT_B_ID = theme.gwpBuyXGetY.set2.id; 
  const THRESHOLD_A = theme.gwpBuyXGetY.set1.threshold;
  const THRESHOLD_B = theme.gwpBuyXGetY.set2.threshold;
  const PRODUCT_A_QTY = theme.gwpBuyXGetY.set1.quantity === 0 ? 1 : theme.gwpBuyXGetY.set1.quantity || 1;
  const PRODUCT_B_QTY = theme.gwpBuyXGetY.set2.quantity === 0 ? 1 : theme.gwpBuyXGetY.set2.quantity || 1;
  const PRODUCT_A_list_product_id = theme.gwpBuyXGetY.set1.list_product_id;
  const PRODUCT_B_list_product_id = theme.gwpBuyXGetY.set2.list_product_id;
  const productIdArray_set1 = (PRODUCT_A_list_product_id != '') ? PRODUCT_A_list_product_id.split(',') : "";
  const productIdArray_set2 = (PRODUCT_B_list_product_id != '') ? PRODUCT_B_list_product_id.split(',') : "";

  console.log("buyxgety ???? ", enablePromotion);
 

  if (enablePromotion) {
    try {
      let responseCart = await fetch(theme.routes.cart, {
        credentials: "same-origin",
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });
      
      const data = await responseCart.json();
      let cartTotal = parseInt(data.total_price);
      console.log("cartTotal ----  ", cartTotal);
      if (cartTotal) {
        const formatCartPrice = parseInt(cartTotal / 100);
        // check if the product exists in the cart
        let productAExists = data.items.some(item => item.variant_id === PRODUCT_A_ID && item.properties['__buyxgety']);
        let productBExists = data.items.some(item => item.variant_id === PRODUCT_B_ID && item.properties['__buyxgety']);

        // get the free gift product from the cart
        let getProductAExists = data.items.find(item => item.variant_id === PRODUCT_A_ID && item.properties['__buyxgety']);
        let getProductBExists = data.items.find(item => item.variant_id === PRODUCT_B_ID && item.properties['__buyxgety']);

        // verify if each product variant_id in the cart belongs to the collection
        const productExistinCollectionSet1 = data.items.some(item => productIdArray_set1.includes(item.variant_id.toString()));
        const productExistinCollectionSet2 = data.items.some(item => productIdArray_set2.includes(item.variant_id.toString()));

        let formBodyAdd = [];
        let formBodyRemove = {};

        // Promotion 2: Buy X Get Y Off
        if (formatCartPrice < THRESHOLD_B && productBExists) {
          formBodyRemove[getProductBExists?.id] = 0;
        } else if (formatCartPrice >= THRESHOLD_B && !productBExists && PRODUCT_B_ID != '' && productExistinCollectionSet2) {
          formBodyAdd.push({
            id: PRODUCT_B_ID,
            quantity: parseInt(PRODUCT_B_QTY),
            properties: {
              __buyxgety: true
            }
          });
          console.log('PROMOTION 2 === ',  formatCartPrice >= THRESHOLD_B, !productBExists, PRODUCT_B_ID != '', productExistinCollectionSet2)
          console.log("formBodyAdd ----  ", formBodyAdd);
        }

        // Promotion 1: Buy X Get Y Off
        if (formatCartPrice < THRESHOLD_A && productAExists) {
          formBodyRemove[getProductAExists?.id] = 0;
        } else if (formatCartPrice >= THRESHOLD_A && !productAExists && PRODUCT_A_ID != '' && productExistinCollectionSet1) {
          formBodyAdd.push({
            id: PRODUCT_A_ID,
            quantity: parseInt(PRODUCT_A_QTY),
            properties: {
              __buyxgety: true
            }
          });

          console.log('PROMOTION 1 === ',  formatCartPrice >= THRESHOLD_A, !productAExists, PRODUCT_A_ID != '', productExistinCollectionSet1)
          console.log("formBodyAdd ----  ", formBodyAdd);
        }

        if (data.item_count <= 1) {
          if (productAExists) {
            formBodyRemove[getProductAExists?.id] = 0;
          } else if (productBExists) {
            formBodyRemove[getProductBExists?.id] = 0;
          }
        }
 
        console.log("formBodyRemove ----  ", formBodyRemove);
        // add free gift product to cart
        if (formBodyAdd.length > 0) {
          await addProductToCart(formBodyAdd);
        }

        // remove free gift product from the cart
        if (Object.keys(formBodyRemove).length > 0) {
          await removeProductFromCart(formBodyRemove);
        }
      }
    } catch (error) {
      console.error('Error fetching cart data:', error);
    }
  }

  // Function to add product to cart
  async function addProductToCart(formData) {
    if (formData !== '') {
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ 'items': formData })
        });
        const data = await response.json();
        console.log('=== BuyXgetY added:', data);
        document.dispatchEvent(new CustomEvent('cart:build'));
      } catch (error) {
        console.error('Error adding product:', error);
      }
    }
  }

  // Function to remove product from cart
  async function removeProductFromCart(formData) {
    if (Object.keys(formData).length > 0) {
      try {
        const response = await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ updates: formData })
        });
        const data = await response.json();
        console.log('==== BuyXgetY removed:', data);
        document.dispatchEvent(new CustomEvent('cart:build'));
      } catch (error) {
        console.error('Error removing product:', error);
      }
    }
  }



  const addOnPopup = document.querySelectorAll('[data-addon-button]');
  if (addOnPopup.length > 0) {
    // Add event listener to AddOnPopup
    addOnPopup.forEach((popup) => {
      popup.addEventListener('click', () => {
      let wcAddonPopupButton = document.querySelectorAll('wc-addon-popup-button');
      // Trigger click event on AddOnPopupButton to open the popup only once
      if (wcAddonPopupButton.length > 0 && !popup.dataset.clicked) {
        wcAddonPopupButton[0].querySelector('button').click();
        popup.dataset.clicked = true; // Mark as clicked
      }
      });
    });

    // remove hidden class from pwp-container
    const pwpContainer = document.querySelectorAll('.pwp-container');
    pwpContainer.forEach((container) => {
      container.classList.remove('hidden')
    }); 

    // Show AddOnPopup once
    if (!sessionStorage.getItem('addOnPopupShownOnce') || sessionStorage.getItem('addOnPopupShownOnce') != 'true') {
      let responseCart = await fetch(theme.routes.cart, {
            credentials: "same-origin",
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          });
      const _data = await responseCart.json();
      let parseData = parseInt(_data.total_price);
      if(parseData > 0) {
        addOnPopup[0].click();
        setTimeout(() => {
          sessionStorage.setItem('addOnPopupShownOnce', true);
        }, 1000);
      }
    }
  }

}

